export default __webpack_public_path__ + "static/media/HelveticaNeue-Medium.de83c5ae.woff";